export default __webpack_public_path__ + "static/media/Group630.e87f4d5e.png";